import { createAsyncThunk } from '@reduxjs/toolkit'
import { AccountId, TokenSymbol } from '../../../types'
import { RootState } from '../../index'
import { getAccountBalance } from '../../../api/v1/account'
import { Equal } from '../../../utils/equal'
import { e2w } from '../../../utils/number'
import { CurrencyBalance } from '../types'

export const getAccountBalanceAction = createAsyncThunk<
  CurrencyBalance[],
  AccountId,
  {
    state: RootState
  }
>('account/getAccountBalanceAction', async (accountId, { getState }) => {
  const state = getState()
  const { trades } = state.market
  const { currencies = [] } = trades

  const r = await getAccountBalance(accountId)
  const { data } = r
  const tokenSymbols: TokenSymbol[] = Object.keys(data)
  const list: CurrencyBalance[] = tokenSymbols.map((v) => {
    const currency = currencies.find((c) => Equal.upperCase(c.name, v))
    return {
      currencyId: currency?.id!,
      currency: v,
      main: currency?.main!,
      available: e2w(data[v][0]).toString(),
      freeze: e2w(data[v][1]).toString(),
    }
  })
  return list
})
